<template>
  <div>
    <div class="row page-title">
      <label class="Agency-Name-HFM-Co">
        {{ Request.VendorBusinessName}} </label>
    </div>
    <div class="row icreview-component">
      <prodexp-amend-overview class="col-lg-8" :ID="id" v-on:LoadProdEXPAmendDetails="LoadVendorRequestDetails"></prodexp-amend-overview>
      <div class="col-lg-4" v-if="IsDataLoaded">
        <div class="py-2 px-1">
          <b-alert :show="!IsApproveOrRejectEnabled" class="alert-info-new position-fixed fixed-top m-0 rounded-0" variant="info" dismissible>
              The Request is already approved or rejected.
          </b-alert>
          <b-alert :show="IsApproveOrRejectEnabled && IsRequestApprovedBySameUser" class="alert-info-new position-fixed fixed-top m-0 rounded-0" variant="info" dismissible>
            This request has already been approved by you.
          </b-alert>
          <p class="approve-reject-label px-3 pt-2 pb-1">
            Approve or Reject the Amend Production / Expense Vendor
          </p>
          <div class="fieldborder" style="margin-top: -4px">
              <label for="axlocatoin" class="lbltxt">Additional Documentation</label>
              <vue-dropzone :duplicateCheck="true" ref="myAdditionalDocumentationVueDropzone" id="dropzone" :useCustomSlot="true"
                  class="customdropzone" :include-styling="false" :options="dropzoneOptions"
                  v-on:vdropzone-file-added="UploadedToDropzone" v-on:vdropzone-removed-file="RemovedFromDropzone">
                  <div class="dropzone-custom-content">
                      <p class="Drag-and-drop-file-h">
                          <b-img style="
                  margin-top: -7px !important;
                  font-family: 'Open Sans';
                " />
                          Drag and drop template here or
                          <span class="draganddropspan"> browse </span>

                      </p>
                  </div>
              </vue-dropzone>
              <div class="note-section mt-2">
                  <p>Acceptable file types: {{ AllowedFileUploadTypes }}.</p>
              </div>
          </div>
          <p class="approve-reject-content mt-2 pb-2 px-3">
            When approved, this request will be sent to the {{RouteToAccountingApproval === 'yes' ? 'Accounting Approver' : 'Financial System Team to be completed'}}.
          </p>
          <div  class="approve-reject-content px-3 py-2">
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-checkbox-group id="checkbox-group-2" v-model="RouteToAccountingApproval" :aria-describedby="ariaDescribedby" name="flavour-2">
                <b-form-checkbox value="yes">Route to Accounting Approval?</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
            <div v-if="RouteToAccountingApproval == 'yes'">
                <label class="">Route to Accounting Approval Comments</label>
                <b-textarea class="rejection-comments-new m-custom" placeholder="Enter Route to Accounting Approval" v-model="AccountingApprovalComments">
                </b-textarea>
            </div>
          </div>
          <div class="approve-reject-content px-3 pt-2">
              <b-form-group>
                  <label class="label">If this vendor is being paid by ACH, was the ACH information able to be validated through the JP Morgan tool?</label>
                  <b-form-radio-group class="ml-2" v-model="IsVendorPaidACH" id="IsVendorPaidACH" name="IsVendorPaidACH">
                      <b-form-radio :value="true">Yes</b-form-radio>
                      <b-form-radio :value="false">No</b-form-radio>
                      <b-form-radio :value="null">N/A</b-form-radio>
                  </b-form-radio-group>
              </b-form-group>
          </div>
          <div class="approve-reject-content px-3 pt-2" v-if="IsVendorPaidACH == true || IsVendorPaidACH == 'true'">
              <b-form-group>
                  <label class="label">Did the ACH information that was input into our system pass validation?</label>
                  <b-form-radio-group class="ml-2" v-model="IsValidACHInformation" id="IsValidACHInformation" name="IsValidACHInformation">
                      <b-form-radio value="true">Yes</b-form-radio>
                      <b-form-radio value="false">No</b-form-radio>
                  </b-form-radio-group>
              </b-form-group>
          </div>
          <div class="fieldborder mb-4" style="margin-top: -4px" v-if="IsValidACHInformation == true || IsValidACHInformation == 'true'">
              <label for="axlocatoin" class="lbltxt">Final Bank Validation</label>
              <vue-dropzone :duplicateCheck="true" ref="myBankValidationAttachment" id="dropzone" :useCustomSlot="true"
                  class="customdropzone" :include-styling="false" :options="dropzoneBankAttachmentOptions"
                  v-on:vdropzone-file-added="UploadedToBankValidationAttachment" v-on:vdropzone-removed-file="RemovedFromBankValidationAttachment">
                  <div class="dropzone-custom-content">
                      <p class="Drag-and-drop-file-h">
                          <b-img style="
                  margin-top: -7px !important;
                  font-family: 'Open Sans';
                " />
                          Drag and drop template here or
                          <span class="draganddropspan"> browse </span>

                      </p>
                  </div>
              </vue-dropzone>
              <div class="note-section mt-2">
                  <p>Acceptable file types: {{ AllowedFileUploadTypes }}.</p>
              </div>
          </div>
          <div class="text-right pb-3 pr-3" style="width: 100%">
            <button v-if="IsApproveOrRejectEnabled && !IsRequestApprovedBySameUser && IsFormValid" class="btn custom-button btn-primary" @click="Approve()">
              Approve
            </button>
            <button v-else class="btn custom-button btn-primary" disabled="disabled"
              title="The request is already approved or rejected.">
              Approve
            </button>
          </div>
        </div>
        <div class="py-2 my-2 px-3">
          <label class="">Rejection Comments</label>
          <b-textarea class="rejection-comments-new m-custom" placeholder="Enter Rejection Comments" v-model="Comments" v-bind:class="{
            errorborder: displaycommentserror && showCommentsError,
            noterrorborder: !displaycommentserror || !showCommentsError,
          }" @blur="SetDirty()" @focus="ResetDirty()" rows="5">
          </b-textarea>
          <div class="error-message-format required-field" v-if="displaycommentserror && showCommentsError">
            Required field
          </div>
          <div class="text-right" style="width: 100%; padding-top: 10px">
            <button v-if="IsApproveOrRejectEnabled && !IsRequestApprovedBySameUser" class="btn custom-button btn-outline-primary" @click="Reject()">
              Reject
            </button>
            <button v-else class="btn custom-button btn-outline-primary" disabled="disabled"
              title="The request is already approved or rejected.">
              Reject
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { required } from "vuelidate/lib/validators";
import * as status from "../../../utilities/VendorWorkflowStates";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import * as AllowedFileUploadExtensions from "../../../utilities/AllowedFileUploadExtensions";

export default {
  name: 'ApprovalLevel3',
  validations: {
    Comments: {
      required,
    },
  },
  data() {
    return {
      AdditionalDocumentationFileCount: false,
      BankValidationAttachmentFileCount: false,
      ApprovalLevel2Attachments :{
          ApprovalAttachment: [],
          BankValidationAttachment:  [],
      },
      deleteIcon: require("@/assets/Icons/delete.svg"),
      AllowedFileUploadTypes: AllowedFileUploadExtensions.FileUploadExtensions.join(", "),
      dropzoneOptions: {
          paramName: "file",
          previewTemplate: this.template(),
          url: `${process.env.VUE_APP_API_ROOT}api/v1/mdm/Upload`,
          uploadMultiple: true,
          maxFiles: 10,
          minFiles: 1,
          maxFilesize: 10,
          addRemoveLinks: false,
          parallelUploads: 10,
          createImageThumbnails: false,
          autoProcessQueue: false,
          init: function () {
              this.on("addedfile", function (file) {
                  if (this.files.length > 10) {
                      this.removeFile(file);
                      window.alert("Maximum File Upload limit is 10!");
                  }
              });

              this.on("removedfile", function () { });
          },
          accept: function(file, done) {
            let fileExtension = file.name.split('.').pop().toLowerCase();
            if (!AllowedFileUploadExtensions.FileUploadExtensions.includes(fileExtension)) {
                store.dispatch(
                    "progress/setErrorMessage",
                    `Unsupported file type. Please upload a valid file type.`
                );
                this.removeFile(file);
            } else {
                done();
            } 
          },
      },
      dropzoneBankAttachmentOptions: {
          paramName: "file",
          previewTemplate: this.template(),
          url: `${process.env.VUE_APP_API_ROOT}api/v1/mdm/Upload`,
          uploadMultiple: true,
          maxFiles: 5,
          minFiles: 1,
          maxFilesize: 5,
          addRemoveLinks: false,
          parallelUploads: 5,
          createImageThumbnails: false,
          autoProcessQueue: false,
          init: function () {
              this.on("addedfile", function (file) {
                  if (this.files.length > 5) {
                      this.removeFile(file);
                      window.alert("Maximum File Upload limit is 5!");
                  }
              });

              this.on("removedfile", function () { });
          },
          accept: function(file, done) {
            let fileExtension = file.name.split('.').pop().toLowerCase();
            if (!AllowedFileUploadExtensions.FileUploadExtensions.includes(fileExtension)) {
                store.dispatch(
                    "progress/setErrorMessage",
                    `Unsupported file type. Please upload a valid file type.`
                );
                this.removeFile(file);
            } else {
                done();
            } 
          },
      },
      displaycommentserror: false,
      Request: {},
      Comments: "",
      showCommentsError: false,
      RouteToAccountingApproval: false,
      userEmail: null,
      IsVendorPaidACH: undefined,
      IsValidACHInformation: null,
      AccountingApprovalComments: "",
      ValidBankAttachments: false,
    };
  },
  props: ["id"],
  components: {
      vueDropzone: vue2Dropzone
  },
  mounted() {
    if (!this.canApprovePendingMdaManager) {
      this.$router.push({
        name: "error",
        params: { message: "UnAuthorized" },
      });
    }
    else {
      this.getEmailFromStore();
    }
  },
  watch: {
      "RouteToAccountingApproval": function (val) {
        if (val === false) {
              this.AccountingApprovalComments = "";
          }
      },
      "IsVendorPaidACH": function (val) {
          if (val == false || val == null) {
              this.IsValidACHInformation = null;
          }
      },
      "IsValidACHInformation": function (val) {
          if (val) {
              this.$set(this.ApprovalLevel2Attachments, "BankValidationAttachment", this.GetFilesBankValidationAttachment());
          }
      },
  },
  computed: {
    IsAccountingApprovalComments() {
        return this.RouteToAccountingApproval === 'yes' && this.AccountingApprovalComments !== '';
    },
    IsFormValid() {
        if (this.RouteToAccountingApproval === 'yes' && !this.AccountingApprovalComments) {
            return false;
        }
        if (this.IsVendorPaidACH === false || this.IsVendorPaidACH === null) {
            return true;
        }
        if (this.IsVendorPaidACH === true && this.IsValidACHInformation === null) {
            return false;
        }
        if (this.IsVendorPaidACH === true && this.IsValidACHInformation === 'false') {
            return true;
        }
        if (this.IsVendorPaidACH === true && this.IsValidACHInformation === 'true' && this.ValidBankAttachments) {
            return true;
        }
        return false;
    },
    IsApproveOrRejectEnabled(){
      return this.Request && this.Request.Status == status.MdaManagerApproval;
    },
    IsRequestApprovedBySameUser(){
      return this.Request && this.Request.DirectorApprovalBy && this.Request.DirectorApprovalBy.toLowerCase() == this.userEmail.toLowerCase();
    },
    IsDataLoaded() {
      return this.Request && !(this.Request.Status == "" || this.Request.Status == null);
    },
    canApprovePendingMdaManager() {
      return this.$store.getters.canApprovePendingMdaManagerVendorRequest;
    }
  },
  methods: {
    LoadVendorRequestDetails(vendorRequestDetails){
      this.Request = vendorRequestDetails;
    },
    SetDirty() {
      if (this.Comments.length > 0) {
        this.showCommentsError = false;
      } else {
        this.showCommentsError = true;
      }
    },
    ResetDirty() {
      this.showCommentsError = false;
    },
    GetData() {
      return {
        ID: parseInt(this.id),
        Comments: this.Comments,
        ActiveTaskID: this.Request.ActiveTaskID,
        ProjectID: this.Request.OmniflowProjectID,
        ProcessID: this.Request.OmniflowProcessID,
        Requestor: this.Request.Requestor,
        AccountingApprovalRequired: this.RouteToAccountingApproval == true || this.RouteToAccountingApproval=="yes" ? true : false,
        IsVendorPaidACH: this.IsVendorPaidACH,
        IsValidACHInformation: this.IsValidACHInformation == "true" ? true : false,
        AccountingApprovalComments: this.AccountingApprovalComments,
      };
    },
    async getEmailFromStore() {
      try {
        const resEmail = await this.$store.dispatch("getEmail");
        this.userEmail = resEmail.toLowerCase();
      } catch (ex) {
        if (ex.response) {
            this.$store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
        }
      }
    },
    Approve() {
      let formData = new FormData();
      formData.append('action', JSON.stringify(this.GetData()));
      if (this.$refs.myAdditionalDocumentationVueDropzone && this.$refs.myAdditionalDocumentationVueDropzone.dropzone && this.$refs.myAdditionalDocumentationVueDropzone.dropzone.files) {
          let filesData = this.$refs.myAdditionalDocumentationVueDropzone.dropzone.files;
          for (var i = 0; i < filesData.length; i++) {
              let fileArray = filesData[i];
              formData.append('ApprovalAttachment', fileArray);
              this.AdditionalDocumentationFileCount = true;
          }
      } else {
          this.AdditionalDocumentationFileCount = false;
      }
      if (this.$refs.myBankValidationAttachment && this.$refs.myBankValidationAttachment.dropzone && this.$refs.myBankValidationAttachment.dropzone.files) {
          let files = this.$refs.myBankValidationAttachment.dropzone.files;
          for (var j = 0; j < files.length; j++) {
              let newFiles = files[j];
              formData.append('BankValidationAttachment', newFiles);
              this.BankValidationAttachmentFileCount = true;
          }
      } else {
          this.BankValidationAttachmentFileCount = false;
      }
      if(this.AdditionalDocumentationFileCount === false) {
          formData.append('ApprovalAttachment', "[]");
      }
      if(this.BankValidationAttachmentFileCount === false) {
          formData.append('BankValidationAttachment', "[]");
      }
      this.$store
        .dispatch("prodexpamend/ApproveRequestLevel3", formData)
        .then(() => {
          store.dispatch(
            "progress/setSuccessMessage",
            `The request ${this.Request.VendorBusinessName} has been approved`
          );
          this.$router.push("/VendorRequests");
        })
        .catch((ex) => {
          if (ex.response) {
            this.SetErrorMessage(
              "Error while approving request",
              ex.response.data
            );
          } else {
            this.SetErrorMessage("Error while approving request", ex);
          }
        });
    },

    Reject() {
      if (this.Comments.length > 0) {
        this.displaycommentserror = false;
        this.$store
          .dispatch("prodexpamend/RejectRequestLevel3", this.GetData())
          .then(() => {
            store.dispatch(
              "progress/setSuccessMessage",
              `Request ${this.Request.VendorBusinessName} has been rejected`
            );
            this.$router.push("/VendorRequests");
          })
          .catch((ex) => {
            window.console.log(JSON.stringify(ex.response));
            if (ex.response) {
              this.SetErrorMessage(
                "Error while rejecting request",
                ex.response.data
              );
            } else {
              this.SetErrorMessage("Error while rejecting request", ex);
            }
          });
      } else {
        this.displaycommentserror = true;
        this.showCommentsError = true;
      }
    },
    SetErrorMessage(message, ex) {
      store.dispatch(
        "progress/setErrorMessage",
        `${message} ${this.Request.VendorBusinessName}. The error is ${ex}`
      );
    },
    UploadedToDropzone() {
        this.$set(this.ApprovalLevel2Attachments, "ApprovalAttachment", this.GetFilesObject());
    },
    RemovedFromDropzone() {
        this.$set(this.ApprovalLevel2Attachments, "ApprovalAttachment" ,this.GetFilesObject());
        this.AdditionalDocumentationFileCount = false;
    },
    GetFilesObject() {
        let files = [];
        if (this.$refs.myAdditionalDocumentationVueDropzone.dropzone.files && this.$refs.myAdditionalDocumentationVueDropzone.dropzone.files.length > 0) {
            let filesExists = this.$refs.myAdditionalDocumentationVueDropzone.dropzone.files;
            for (let i = 0; i < filesExists.length; i++) {
                files.push({
                    name: filesExists[i].name,
                    file: filesExists[i]
                });
            }
            return files;
        } else {
            return files;
        }
    },
    ManuallyUploadFiles(files) {
        if (files != null && files.length > 0) {
            files.forEach((fileUploaded) => {
                let file = {
                    size: fileUploaded.Length,
                    name: fileUploaded.Name,
                    type: fileUploaded.Extension,
                };
                var url = fileUploaded.FullName;
                this.$refs.myAdditionalDocumentationVueDropzone.manuallyAddFile(file, url);
            });
        }
    },
    UploadedToBankValidationAttachment() {
        this.$set(this.ApprovalLevel2Attachments, "BankValidationAttachment", this.GetFilesBankValidationAttachment());
    },
    RemovedFromBankValidationAttachment() {
        this.$set(this.ApprovalLevel2Attachments, "BankValidationAttachment", this.GetFilesBankValidationAttachment());
        this.BankValidationAttachmentFileCount = false;
    },
    GetFilesBankValidationAttachment() {
        let files = [];
        if (this.$refs.myBankValidationAttachment.dropzone.files && this.$refs.myBankValidationAttachment.dropzone.files.length > 0) {
            let filesExists = this.$refs.myBankValidationAttachment.dropzone.files;
            for (let i = 0; i < filesExists.length; i++) {
                files.push({
                    name: filesExists[i].name,
                    file: filesExists[i]
                });
            }
            if(files.length > 0) {
                this.ValidBankAttachments = true;
            }
            return files;
        } else {
            this.ValidBankAttachments = false;
            return files;
        }
    },
    ManuallyUploadFilesBankValidationAttachment(files) {
        if (files != null && files.length > 0) {
            files.forEach((fileUploaded) => {
                let file = {
                    size: fileUploaded.Length,
                    name: fileUploaded.Name,
                    type: fileUploaded.Extension,
                };
                var url = fileUploaded.FullName;
                this.$refs.myBankValidationAttachment.manuallyAddFile(file, url);
            });
        }
    },
    template: function () {
        return `<div class="dz-preview dz-file-preview" style='background-color:#ffffff !important;display:flex;'>

            <div class="dz-details" style='margin-right:79px !important;'>
                <div class="dz-size" style="display:none;" ><span data-dz-size></span></div>
                <div class="FileforNewClientxls-Copy" style="margin-left:20px;width:280px;cursor:default !important;" ><span style='word-break:break-all !important;font-size:14px !important;font-weight:400;font-stretch:normal;font-style: normal;line-height: 0.71;color: #00a1d2 !important; font-family:"Open Sans" !important;' data-dz-name></span></div>
            </div>
            <a>
              <img data-dz-remove=""  style='' src='/icons/fileremove.svg'  @click="DeleteServerFile()" ></img>
            </a>
        </div>`;
    },
  },
};
</script>

<style scoped>
.label {
    line-height:normal;
}
.customdropzone {
    width: auto !important;
    height: auto !important;
    border-radius: 8px !important;
    border: dashed 2px #e9eef0 !important;
    background-color: #ffffff !important;
    cursor: pointer !important;
}

.Drag-and-drop-file-h {
    margin-left: 18px !important;
    margin-top: 14px !important;
    width: 387px !important;
    height: 10px !important;
    font-family: "Open Sans" !important;
    font-size: 14px !important;
    font-weight: normal !important;
    font-stretch: normal !important;
    font-style: normal !important;
    line-height: 0.71 !important;
    letter-spacing: normal !important;
    /* color: #a2a9ad !important; */
}

.zipcodevalidationmsg {
    /* margin-top: -20px !important; */
    width: 157px !important;
    font-size: 10px !important;
    color: #df5678 !important;
    font-family: "Open Sans" !important;
    font-size: 11px !important;
    font-weight: normal !important;
    font-stretch: normal !important;
    font-style: italic !important;
    line-height: 0.8 !important;
    letter-spacing: normal !important;
    text-align: left !important;
}

.error-message1 {
    height: 14px !important;
    font-size: 10px !important;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #df5678 !important;
}

.draganddropspan {
    color: #00a1d2;
}

.error-message {
    padding-top: 10px;
    padding-bottom: 5px;
    height: 14px !important;
    font-size: 12px !important;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #df5678 !important;
}
</style>